import React from 'react';
import { Box } from '@fortress-technology-solutions/fortress-component-library/Atoms';
import NavIconList from './NavIconList';
import NavIconTextList from './NavIconTextList';
import useDrawerContent from './DrawerContent.hooks';

const DrawerContent = ({
  drawerWidth,
  environmentName,
  flags,
  isXs,
  navOptionsArray,
  propertyDetails,
  showNavText,
}) => {
  const {
    initialOpenState,
    open,
    isTransitioning,
    setIsTransitioning,
    previousHeight,
    setPreviousHeight,
    activeMenu,
    isNavigatingDown,
    resetHeight,
    handleSetOpen,
  } = useDrawerContent({ flags, navOptionsArray });

  return (
    <Box
      sx={{
        position: 'relative',
        overflow: 'hidden',
        height: '100%',
        width: '100%',
        marginTop: { sm: '40px' },
      }}
    >
      <NavIconList
        drawerWidth={drawerWidth}
        isXs={isXs}
        navOptionsArray={navOptionsArray}
        showNavText={showNavText}
        flags={flags}
      />
      <NavIconTextList
        environmentName={environmentName}
        flags={flags}
        initialOpenState={initialOpenState}
        isXs={isXs}
        navOptionsArray={navOptionsArray}
        open={open}
        propertyDetails={propertyDetails}
        setOpen={handleSetOpen}
        showNavText={showNavText}
        {...(flags.navigationMenuUxImprovements && {
          isTransitioning,
          setIsTransitioning,
          previousHeight,
          setPreviousHeight,
          activeMenu,
          isNavigatingDown,
          resetHeight,
        })}
      />
    </Box>
  );
};

DrawerContent.defaultProps = {
  showNavText: true,
  environmentName: '',
  navOptionsArray: [],
};

export default DrawerContent;
